<div class="card-container">
    <div class="card">
        <div class="success-icon">
            <img src="../../../assets/ok.svg" alt="Success" />
        </div>
        <div class="heading">Subscription Success!</div>
        <div class="sub-heading">Your subscription to Evaltrix has been successful. Please reach
            <a href="mailto:support@evaltrix.com" target="_blank" rel="noopener noreferrer" class="email-link"
                (click)="openEmailClient()">support&#64;evaltrix.com</a> for any assistance.
        </div>
        <div class="btn-sec">
            <button mat-stroked-button color="primary" (click)="gotoSettings()">Go to Settings</button>
            <button mat-raised-button color="primary" (click)="createAssessment()">Create Assessment</button>
        </div>
    </div>
</div>